var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column align-items-center"},[_vm._m(0),_c('SectionForm',{attrs:{"mode":'edit'},on:{"save":_vm.UpdateSection,"delete":_vm.DeleteSection},model:{value:(_vm.section),callback:function ($$v) {_vm.section=$$v},expression:"section"}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 d-flex justify-content-center"},[_c('h2',[_vm._v("Editar a seção")])])
}]

export { render, staticRenderFns }